import { FC } from 'react';
import { useUserContext } from '../../../../providers/UserProvider';
import { useTranslations } from '../../../../hooks/useTranslationsHelper';
import { AccountDetails } from '../AccountDetails';
import { AccountDetailsEditModal } from '../MyProfile/AccountDetailsEditModal';
import { useSnackbar } from '../../../../hooks/snackbar';

export const DirectMarketingPrompt: FC = () => {
  const { t } = useTranslations();
  const { addSnack } = useSnackbar();
  const { consents } = useUserContext();
  const show = consents?.productMarketingAllowed?.casino === null || consents?.productMarketingAllowed?.sports === null;

  const handleUpdateSuccess = (): void => {
    addSnack({
      type: 'success',
      message: t('my-account.home.my-profile.update-success'),
      theme: 'dark',
    });
  };

  const handleUpdateFailure = (): void => {
    addSnack({
      type: 'error',
      theme: 'dark',
      message: t('my-account.home.my-profile.update-failed'),
    });
  };

  return show ? (
    <AccountDetails
      isMarketingSettings
      onError={handleUpdateFailure}
      onUpdate={handleUpdateSuccess}
      EditModalComponent={AccountDetailsEditModal}
      editMode="modal"
      editTitle={t('my-account.home.settings.communication.settings')}
      id="marketing-details"
      forceDisplayEditModal={show}
      canDismiss={false}
      fieldSets={[
        {
          id: 'marketing-details-fieldset',
          label: 'Please review your marketing preferences',
          labelSrOnly: true,
          editDescription:
            'You now have more choice in how you’re notified about personalised promotions, free bets, exclusive offers, and Betzone updates. Please confirm your choices below.',
          fields: [
            {
              name: 'toggleAllMarketing',
              columns: 12,
              overviewColumns: 12,
              hidden: false,
            },
            {
              name: 'optInEmailCasino',
              columns: 12,
              overviewColumns: 12,
              hidden: false,
            },
            {
              name: 'optInSmsCasino',
              columns: 12,
              overviewColumns: 12,
              hidden: false,
            },
            {
              name: 'optInTelephoneCasino',
              columns: 12,
              overviewColumns: 12,
              hidden: false,
            },
            {
              name: 'optInEmailSport',
              columns: 12,
              overviewColumns: 12,
              hidden: false,
            },
            {
              name: 'optInSmsSport',
              columns: 12,
              overviewColumns: 12,
              hidden: false,
            },
            {
              name: 'optInTelephoneSport',
              columns: 12,
              overviewColumns: 12,
              hidden: false,
            },
          ],
        },
      ]}
    />
  ) : null;
};
